export default "__VITE_ASSET__C7D$drXO__"